<template>
  <div class="schedule_module">
    <vs-tabs v-model="tabIndex" class="unique_cstm_tab cstm_line_tabular_view">
      <!-- v-if="checkTeacherSchedulePermission() && is_course" -->
      <vs-tab v-if="getSubModulePermission('Schedule', 'Teacher Schedule', 'View')"
        @click="colorx = 'success'"
        label="Teachers"
      >
        <teacher-calendar-component
          name="Teachers"
        ></teacher-calendar-component>

        <!--  <calendar-component
          name="Teachers"

     ></calendar-component> -->
      </vs-tab>

      <!-- v-if="checkStudentSchedulePermission() && is_course" -->
      <vs-tab v-if="getSubModulePermission('Schedule', 'Student Schedule', 'View')"
        @click="colorx = 'success'"
        label="Students"
      >
        <student-calendar-component
          name="Students"
        ></student-calendar-component>
        <!--   <calendar-component
     name="Student"
     ></calendar-component> -->
      </vs-tab>

      <!-- <vs-tab
        @click="colorx = 'success'"
        label="Cancelled Schedule"
        v-if="checkTeacherSchedulePermission()"
      >
        <CancelcalendarComponent name="cancel"></CancelcalendarComponent>
      </vs-tab> -->
      <!--  <vs-tab @click="colorx = 'success'" label="Rooms">
        <calendar-component name="Room"></calendar-component>
      </vs-tab> -->
      <vs-tab v-if="getSubModulePermission('Schedule', 'Room Schedule', 'View')"
        @click="colorx = 'success'"
        label="Rooms"
      >
        <room-calendar-component name="Room"></room-calendar-component>
      </vs-tab>
      <vs-tab @click="colorx = 'success'" label="General" v-if="getSubModulePermission('Schedule', 'General Schedule', 'View')">
        <general-calendar-component
          name="General"
          :custom="1"
        ></general-calendar-component>
        <!--     <calendar-component
      name="General"
      :custom="1"
     ></calendar-component> -->
      </vs-tab>

      <!-- <vs-tab
        @click="colorx = 'success'"
        label="Student Classes"
        v-if="checkStudentClassScheduleViewPermission() && is_class"
      >
        <student-class-calendar-component
          name="Students"
        ></student-class-calendar-component>
      </vs-tab>

      <vs-tab
        @click="colorx = 'success'"
        label="Teacher Classes"
        v-if="checkTeacherClassScheduleViewPermission() && is_class"
      >
        <teacher-class-calendar-component
          name="Teachers"
        ></teacher-class-calendar-component>
      </vs-tab> -->
    </vs-tabs>
  </div>
</template>
<script>
import CalendarComponent from './CalendarComponent.vue'
import TeacherCalendarComponent from './TeacherCalendarComponent.vue'
import RoomCalendarComponent from './RoomCalendarComponent.vue'
import StudentCalendarComponent from './StudentCalendarComponent.vue'
import GeneralCalendarComponent from './GeneralCalendarComponent.vue'
import CancelcalendarComponent from './CancelcalendarComponent.vue'
import StudentClassCalendarComponent from './StudentClassCalendarComponent.vue'
import TeacherClassCalendarComponent from './TeacherClassCalendarComponent.vue'
import { PermissionMiddleware } from '@/mixins/middleware/v1/PermissionMiddleware'
import { checkCourseOrClass } from '@/api/schedulerApi'

export default {
  components: {
    CalendarComponent,
    TeacherCalendarComponent,
    RoomCalendarComponent,
    StudentCalendarComponent,
    GeneralCalendarComponent,
    CancelcalendarComponent,
    StudentClassCalendarComponent,
    TeacherClassCalendarComponent
  },
  mixins: [PermissionMiddleware],
  computed: {
  },
  data () {
    return {
      tabIndex: 0,
      is_course: false,
      is_class: false
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Schedule')
    }

    this.checkCourseOrClass()
  },
  methods: {
    async checkCourseOrClass () {
      try {
        const payload = {
          customer_id: localStorage.getItem('customer_id')
        }

        const response = await checkCourseOrClass(payload)

        if (response.status === 200) {
          this.is_course = response.data.data.course_exist
          this.is_class = response.data.data.class_exist
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>